import styled from 'styled-components';
import {colorTheme} from '../../../../core/configs';

export const StyledImg = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid ${colorTheme.lightGray};
`;
